import Box from '@mui/material/Box';
import CatalogHomeImage from '../../../assets/catalog-home.svg';
import CatalogHomeDarkImage from '../../../assets/catalog-home-dark.svg';
import { GenericHeader } from '@mb.io/core-components';
import { SupportButton } from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';
import { catalogPlugin } from '@backstage/plugin-catalog';
import { useTheme } from '@mui/material/styles';
import { CustomCreateButton } from './CustomCreateButton/CustomCreateButton';

export const CatalogHeader = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const registerComponentLink = useRouteRef(
    catalogPlugin.externalRoutes.createComponent,
  );

  const to = `${registerComponentLink?.()}`;
  const create = {
    title: 'Create',
    to,
  };

  return (
    <Box data-testid="catalog-header">
      <GenericHeader
        title="Catalog"
        text="The catalog allows you to manage all your software components and related metadata. It provides a unified view of your software ecosystem, enabling you to track ownership, dependencies and documentation."
        imagePath={isDarkMode ? CatalogHomeDarkImage : CatalogHomeImage}
        style={{
          maxHeight: '200px',
        }}
        supportButtons={
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '16px',
            }}
          >
            <SupportButton data-testid="support-button" />
            <CustomCreateButton
              data-testid="create-button"
              title={create.title}
              to={create.to}
            />{' '}
          </Box>
        }
      />
    </Box>
  );
};
